module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Chappaquiddick.964ffdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Chappaquiddick.jpg
// module id = UPAo
// module chunks = 0